import PropTypes from 'prop-types';
import closeButton from '../../images/close-button.svg';

const SizeGuide = ({ open, setOpen, title, body }) => {
	if (!open) return null;

	return (
		<div className="sizeguide-overlay" onClick={() => setOpen(false)}>
			<div className="sizeguide-modal" onClick={e => e.stopPropagation()}>
				<button className="close-button" onClick={() => setOpen(false)}>
					<img src={closeButton} alt="Close" />
				</button>
				<h2>{title}</h2>
				<div className="sizeguide-content" dangerouslySetInnerHTML={{ __html: body }}></div>
			</div>
		</div>
	);
};

SizeGuide.propTypes = {
	open: PropTypes.bool.isRequired,
	setOpen: PropTypes.func.isRequired,
	title: PropTypes.string,
	body: PropTypes.string
};

export default SizeGuide;
